/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_UsageInputs */

const en_mk_shot_usage = /** @type {(inputs: Mk_Shot_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The usage page: cost per agent in rupiah, number of runs and tokens consumed.`)
};

const id_mk_shot_usage = /** @type {(inputs: Mk_Shot_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman pemakaian: biaya per agen dalam rupiah, jumlah run, dan token yang terpakai.`)
};

/**
* | output |
* | --- |
* | "The usage page: cost per agent in rupiah, number of runs and tokens consumed." |
*
* @param {Mk_Shot_UsageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_usage = /** @type {((inputs?: Mk_Shot_UsageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_UsageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_usage(inputs)
	return en_mk_shot_usage(inputs)
});